import { client } from '@/sdk/client.gen';
import { ApiError, rethrow } from './errors';

function getCsrfToken(): string {
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrftoken='))
      ?.split('=')[1] ?? ''
  );
}

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS', 'TRACE']);

interface SdkConfig {
  onUnauthenticated?: () => void;
}

export function initSdk(config: SdkConfig = {}): void {
  client.setConfig({ baseUrl: '/asyncapi/v2' });

  client.interceptors.request.use((request) => {
    if (!SAFE_METHODS.has(request.method.toUpperCase())) {
      request.headers.set('X-CSRFToken', getCsrfToken());
    }
    return request;
  });

  client.interceptors.error.use((body, response) => {
    if (!response) {
      throw new ApiError(
        'Network error: the request did not complete',
        0,
        'urn:app:error:network',
        { cause: body },
      );
    }
    if (response.status === 401) {
      config.onUnauthenticated?.();
    }
    rethrow(body, response.status);
  });
}

export { client };
